import { normalize, denormalize, schema } from 'normalizr';
import { getWebpAwareExtension } from '../helpers/webpSupport';
const benchMaterial = new schema.Entity('benchMaterials');
const panelMaterial = new schema.Entity('panelMaterials');
const profileMaterial = new schema.Entity('profileMaterials');
const glassMaterial = new schema.Entity('glassMaterials');
const glassListMaterial = new schema.Entity('glassListMaterials');
const materialSchema = {
    benchMaterials: [benchMaterial],
    profileMaterials: [profileMaterial],
    panelMaterials: [panelMaterial],
    glassMaterials: [glassMaterial],
    glassListMaterials: [glassListMaterial]
};

var initialState =
{
    materials: normalize({
        benchMaterials: [0],
        profileMaterials: [0],
        panelMaterials: [0],
        glassMaterials: [0],
        glassListMaterials:[0]
    }, materialSchema),
    isFetching: false
}


let imageExtentsion = getWebpAwareExtension();

const materialStore = (state = initialState, action) => {
    switch (action.type) {
        case 'RECEIVE_MATERIAL_UPDATE':        
            return Object.assign({}, state, {
                materials: normalizeMaterials(action) ,  
                isFetching: false
            })
        case 'REQUEST_MATERIAL_UPDATE':
            return Object.assign({}, state, {
                isFetching: true
            })       
        default:
            return state;
    }
}
let normalizeMaterials = (materials) => {    
    return normalize({
        benchMaterials: addRelaxXlMaterials(materials.benchMaterials),
        profileMaterials: materials.profileMaterials,
        panelMaterials: materials.panelMaterials,
        glassMaterials: materials.glassMaterials,
        glassListMaterials: materials.glassListMaterials
    }, materialSchema);
}
let addRelaxXlMaterials = (materials) => {
    materials.filter(m => m.benchModel === "relax").forEach((m) => m.benchModel = "relax,relaxxl");
    return materials;
}


const getMaterials = (state, material) => {
    if (state.materialStore.materials.entities[material]) {
        var input = {};
        input[material] = state.materialStore.materials.result[material];
        var denormalized = denormalize(input, materialSchema, state.materialStore.materials.entities);
        return denormalized[material];
    }
    else return [];
}
export const getBenchMaterials = function (state) {
    var result = getMaterials(state, "benchMaterials");
    result.forEach((r) => {
        r.thumbnail = "img/benchmaterials/" + r.id + imageExtentsion;
    });
    return result;
}
export const getSelectableBenchMaterials = (state) => {
    let normalizedName = state.benchModel.model.name.replace(" ", "").toLowerCase();
    return getBenchMaterials(state).filter(m => m.benchModel.includes(normalizedName));
}


export const getPanelMaterials = function (state) {
    var result = getMaterials(state, "panelMaterials");
    result.forEach((r) => {
        r.thumbnail = "img/panels/" + r.id + imageExtentsion;
    });
    return result;
}
export const getProfileMaterials = function (state) {

    var result = getMaterials(state, "profileMaterials");
    result.forEach((r) => {
        r.thumbnail = "img/profilematerials/" + r.id + imageExtentsion;
    });
    return result;
}

export const getGlassMaterials = function (state) {

    var result = getMaterials(state, "glassMaterials");
    result.forEach((r) => {
        r.thumbnail = "img/glassMaterials/" + r.id + imageExtentsion;
    });
    return result;
}

export const getGlassListMaterials = function (state) {

    var result = getMaterials(state, "glassListMaterials");
    result.forEach((r) => {
        r.thumbnail = "img/glassListMaterials/" + r.id + imageExtentsion;
    });
    return result;
}





export const getBenchMaterial = (state, id) => {
    if (state.materialStore.materials.entities.benchMaterials) {
        var denormalized = denormalize(id, benchMaterial, state.materialStore.materials.entities);
        return denormalized;
    }
}


export const getProfileMaterial = (state, id) => {
    if (state.materialStore.materials.entities.profileMaterials) {
        var denormalized = denormalize(id, profileMaterial, state.materialStore.materials.entities);
        return denormalized;
    }
}

export const getPanelMaterial = (state, id) => {
    if (state.materialStore.materials.entities.panelMaterials) {
        var denormalized = denormalize(id, panelMaterial, state.materialStore.materials.entities);
        return denormalized;
    }
}
export const getGlasslMaterial = (state, id) => {
    if (state.materialStore.materials.entities.glassMaterials) {
        var denormalized = denormalize(id, glassMaterial, state.materialStore.materials.entities);
        return denormalized;
    }
}
export const getGlassListlMaterial = (state, id) => {
    if (state.materialStore.materials.entities.glassListMaterials) {
        var denormalized = denormalize(id, glassListMaterial, state.materialStore.materials.entities);
        return denormalized;
    }
}






export const getDefaultBenchMaterial = (state, model) => {
    let normalizedName = model.name.replace(" ", "").toLowerCase();
    return getBenchMaterials(state).filter(m => m.benchModel.includes(normalizedName))[0];
}
export const getDefaultProfileMaterial = (state, model) => {
    return (state.materialStore.materials.entities.profileMaterials)[0];
}

export default materialStore
